import React from 'react';
import PropTypes from 'prop-types';

import {
  List,
  ListHeader,
  ListHeaderItem,
  ListBody,
  ListItem,
  ListItemColumn,
  MenuList,
  MenuListItem,
  SVGIcon,
  MaterialIcon,
  HOCs,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import enhanceWithNavigation from 'hocs/enhanceWithNavigation';
import { getIcon } from 'Workspace/helpers';
import { KnowledgeTypes } from 'constants/knowledgeMap';
import BaseMoreButton from 'components/MoreButton';

import messages from './messages';
import {
  KnowledgeMapIcon,
  Menu,
  MenuListItemText,
  ListItemUtilityColumn,
  StyledIcon,
} from './styles';


const { enhanceWithPopper } = HOCs;

const LinkListItemColumn = enhanceWithNavigation(ListItemColumn);

const MoreButtonWithPopper = enhanceWithPopper(BaseMoreButton);



const KnowledgeList = ({
  list,
  downloadKnowledgeMap,
  onDeleteOfKnowledgeMap,
  onReplaceKnowledgeMap,
  duplicateKnowledgeMap,
}) => (
  <List>
    <ListHeader>
      <ListItemColumn>
        <ListHeaderItem>
          {intl.formatMessage(messages.knowledgeMapsListHeaderName)}
        </ListHeaderItem>
      </ListItemColumn>
    </ListHeader>
    <ListBody>
      {list.map((knowledgeItem) => (
        <ListItem key={`cohort-item-${knowledgeItem.id}`}>
          <LinkListItemColumn path={`knowledge/${knowledgeItem.id}/content`}>
            <KnowledgeMapIcon>
              <SVGIcon
                icon='duotoneKnowledge'
                viewBox='0 0 24 24'
                fill='#4AD3AC'
                width={{ width: '24px', height: '24px' }}
              />
            </KnowledgeMapIcon>
            {knowledgeItem.title}
          </LinkListItemColumn>
          <ListItemUtilityColumn>
            <MoreButtonWithPopper placement='bottom-end' hidepopperonclick>
              <Menu>
                <MenuList>
                  <MenuListItem
                    onClick={downloadKnowledgeMap(knowledgeItem.id)}
                  >
                    <SVGIcon
                      icon={getIcon(KnowledgeTypes.DOWNLOAD)}
                      viewBox='0 0 24 24'
                    />
                    <MenuListItemText>
                      {intl.formatMessage(messages.download)}
                    </MenuListItemText>
                  </MenuListItem>
                </MenuList>

                <MenuList>
                  <MenuListItem
                    onClick={() => onReplaceKnowledgeMap(knowledgeItem)}
                  >
                    <StyledIcon
                      icon='overwrite'
                    />

                    <MenuListItemText>
                      {intl.formatMessage(messages.overwrite)}
                    </MenuListItemText>
                  </MenuListItem>
                </MenuList>

                <MenuList>
                  <MenuListItem
                    onClick={() => duplicateKnowledgeMap(knowledgeItem)}
                  >
                    <MaterialIcon id={KnowledgeTypes.DUPLICATE} />
                    <MenuListItemText>
                      {intl.formatMessage(messages.duplicate)}
                    </MenuListItemText>
                  </MenuListItem>
                </MenuList>

                {knowledgeItem.isDeleteOptionAllowed && (
                  <MenuList>
                    <MenuListItem
                      onClick={() => onDeleteOfKnowledgeMap(knowledgeItem)}
                    >
                      <MaterialIcon id={KnowledgeTypes.DELETE} />
                      <MenuListItemText>
                        {intl.formatMessage(messages.delete)}
                      </MenuListItemText>
                    </MenuListItem>
                  </MenuList>
                )}
              </Menu>
            </MoreButtonWithPopper>
          </ListItemUtilityColumn>
        </ListItem>
      ))}
    </ListBody>
  </List>
);

KnowledgeList.propTypes = {
  list: PropTypes.array,
  downloadKnowledgeMap: PropTypes.func,
  duplicateKnowledgeMap: PropTypes.func,
};

export default KnowledgeList;
